export const API_URL = "https://skychunks.store/bbadmin/01webapi";
export const uploads = "https://skychunks.store/uploads";